import { render, staticRenderFns } from "./VaPageLayout.vue?vue&type=template&id=46c3491a"
import script from "./VaPageLayout.vue?vue&type=script&lang=js"
export * from "./VaPageLayout.vue?vue&type=script&lang=js"
import style0 from "./VaPageLayout.vue?vue&type=style&index=0&id=46c3491a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports